import type { MarketName } from "@dransay/api/models";
import { useMemo } from "react";
import { useRouteLoaderData } from "react-router";
import { MarketConfigs } from "~/tooling/market/config";
import type { Route } from "../+types/root";

export function useMarket() {
	const loaderData =
		useRouteLoaderData<Route.ComponentProps["loaderData"]>("root");
	const marketCode = (loaderData?.ENV.MARKET ?? "de") as MarketName;
	return useMemo(() => MarketConfigs[marketCode], [marketCode]);
}
